import { DownloadNoteFileBtn } from '@shared/features/notes/download-note-file-btn';
import { Text } from '@src/design-system/text';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@src/design-system/tooltip';
import { NoteCardHeader } from './note-card-header';
import parse from 'html-react-parser';

import type { FC } from 'react';
import type { TLeadNote } from '@src/shared/types/lead-note';
import { dayjsUtils } from '@src/shared/utils/helpers/dayjs';

export const LeadNoteCard: FC<{ note: TLeadNote }> = ({ note }) => {
  return (
    <>
      <div className='relative border rounded-xl border-primary-100 py-3 w-full px-4 mb-3'>
        <NoteCardHeader note={note} />

        <Text className='text-sm text-gray-800 my-4 break-words whitespace-normal'>
          {parse(note.note)}
        </Text>

        <div className='flex items-center mt-2 mb-[2.5rem] flex-wrap gap-3'>
          {note.attachments &&
            note.attachments.length > 0 &&
            note.attachments.map((attachment) => (
              <DownloadNoteFileBtn
                key={attachment.id}
                attachment={attachment}
              />
            ))}
        </div>

        {note.is_resolved && note.resolved_by && (
          <div className='bg-[#E9EAEC] py-0.5 p-1 rounded-md absolute right-5 bottom-4 flex items-center gap-2'>
            <span className='text-[#0F132499] text-xs font-medium flex items-center'>
              Resolved by
              <span className='mx-1 text-base leading-none align-middle'>·</span>
              <Tooltip>
                <TooltipTrigger className='cursor-pointer'>
                  <span>{note.resolved_by.first_name}</span>
                </TooltipTrigger>
                <TooltipContent>
                  <span>
                    {note.resolved_by.first_name} {note.resolved_by.last_name}
                  </span>
                </TooltipContent>
              </Tooltip>
              {note.resolved_at && (
                <>
                  <span className='mx-1 text-base leading-none align-middle'>·</span>
                  {dayjsUtils(note.resolved_at).format('D MMM')}
                </>
              )}
            </span>
          </div>
        )}
      </div>
    </>
  );
};
